import { SET_PRODUCT_COLLECTION_LAYOUT } from '../actions';
import { PRODUCT_COLLECTION_LAYOUT } from '../constants';
import { LayoutMode } from '../types';

type State = {
  userSelectedLayout?: LayoutMode;
};

export default (state: State | undefined = {}, action: any): State => {
  switch (action.type) {
    case 'ROUTE_LOADED': {
      return {
        ...state,
      };
    }

    case SET_PRODUCT_COLLECTION_LAYOUT:
      return {
        ...state,
        userSelectedLayout: action.layout,
      };

    case 'LOCAL_STORAGE_RECEIVE': {
      const productCollectionLayoutFromLocalStorage =
        action.localStorageState[PRODUCT_COLLECTION_LAYOUT];
      return {
        ...state,
        userSelectedLayout:
          typeof productCollectionLayoutFromLocalStorage !== 'undefined'
            ? productCollectionLayoutFromLocalStorage
            : LayoutMode.GRID,
      };
    }
    default:
      break;
  }

  return state;
};
